import { FormConfirmDialog } from "@/components/FormConfirmDialog";
import { VideoEditor } from "./VideoEditor";

import type { Control } from "react-hook-form";
import type { VideoEditorState } from "./VideoEditor";

export function VideoEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<VideoEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <VideoEditor control={control} />
    </FormConfirmDialog>
  );
}
